// Canonical source for all docs.p0.dev URLs.
// Import from here instead of hardcoding URLs in components.

export const DOCS_URLS = {
  // General
  BASE: "https://docs.p0.dev",
  QUICK_START: "https://docs.p0.dev/getting-started/quick-start",
  QUICK_START_CONFIGURE_APPROVER:
    "https://docs.p0.dev/getting-started/quick-start#configure-an-access-approver",
  ACCESS_CONTROL: "https://docs.p0.dev/p0-management/role-based-access-control",
  DIRECTORY: "https://docs.p0.dev/integrations/directory-integrations",
  RESOURCE: "https://docs.p0.dev/integrations/resource-integrations",

  // Just-in-time access
  JIT_BASE: "https://docs.p0.dev/what-is-p0/just-in-time-access",
  JIT_REQUESTING:
    "https://docs.p0.dev/orchestration/just-in-time-access/requesting-access",
  JIT_POLICIES:
    "https://docs.p0.dev/access-management/just-in-time-access/request-routing",
  JIT_POLICY_API:
    "https://docs.p0.dev/access-management/just-in-time-access/just-in-time-api/access-policies-api",
  JIT_CUSTOM_NOTIFIER:
    "https://docs.p0.dev/integrations/notifier-integrations/custom-notifier",

  // IAM assessment
  IAM_ASSESSMENT: "https://docs.p0.dev/what-is-p0/iam-assessment",
  IAM_ASSESSMENT_RUNNING:
    "https://docs.p0.dev/iam-assessment/running-an-iam-assessment",
  IAM_ASSESSMENT_QUERY_SEARCH:
    "https://docs.p0.dev/iam-assessment/query-search",
  IAM_ASSESSMENT_CREATE_ENVIRONMENT:
    "https://docs.p0.dev/environments/creating-an-environment#install-for-iam-data-collection",

  // AWS
  AWS_INSTALL: "https://docs.p0.dev/integrations/resource-integrations/aws",
  AWS_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/aws/requesting-access",
  AWS_IAM_WRITE:
    "https://docs.p0.dev/integrations/resource-integrations/aws#setting-up-aws-iam-management",
  AWS_INVENTORY:
    "https://docs.p0.dev/integrations/resource-integrations/aws#setting-up-aws-resource-inventory",
  AWS_ACCESS_LOGS:
    "https://docs.p0.dev/orchestration/just-in-time-access/session-recording/aws",
  AWS_FUNCTION_CALLER:
    "https://docs.p0.dev/integrations/resource-integrations/aws/function-invocation",
  AWS_RDS_SECURITY_PERIMETER:
    "https://docs.p0.dev/integrations/resource-integrations/postgresql/installing-an-rds-database",

  // Google Cloud
  GCLOUD_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud",
  GCLOUD_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud/requesting-access",
  GCLOUD_SECURITY_PERIMETER:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud/security-perimeter",
  GCLOUD_FUNCTION_CALLER:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud/cloud-run-invocation",

  // Azure
  AZURE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure",
  AZURE_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure/requesting-access",
  AZURE_APP:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure#step-1-install-the-azure-app-registration",
  AZURE_IAM_WRITE:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure#install-iam-management-just-in-time-access",
  AZURE_BASTION_HOST:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure#configure-ssh-access-control-via-bastion",

  DATABRICKS_BEFORE_YOU_BEGIN:
    "https://docs.p0.dev/integrations/resource-integrations/databricks/installation#before-you-begin",
  DATABRICKS_AI_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/agentic-gateway/mcp-server/databricks",

  // GitHub
  GITHUB_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/github",
  GITHUB_BEFORE_YOU_BEGIN:
    "https://docs.p0.dev/integrations/resource-integrations/github#before-you-begin",
  GITHUB_REPOSITORIES_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/github-repositories",
  GITHUB_REPOSITORIES_BEFORE_YOU_BEGIN:
    "https://docs.p0.dev/integrations/resource-integrations/github-repositories#before-you-begin",

  // Docker Hub
  DOCKER_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/docker",

  // 1Password
  ONEPASSWORD_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/1password",

  // Auth0
  AUTH0_INSTALL: "https://docs.p0.dev/integrations/resource-integrations/auth0",

  // Kubernetes
  K8S_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/kubernetes",
  K8S_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/kubernetes/requesting-access",

  // ClickHouse Cloud
  CLICKHOUSE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/clickhouse",

  // Custom resource
  CUSTOM_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/custom-resource",
  CUSTOM_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/custom-resource/installing-a-custom-resource-integration",

  // SSH / Self-hosted / Tailscale / Zscaler
  SSH_INSTALL: "https://docs.p0.dev/integrations/resource-integrations/ssh",
  SELF_HOSTED_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/ssh/self-hosted",
  TAILSCALE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/tailscale",
  ZSCALER_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/zscaler",

  // Database
  SNOWFLAKE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/snowflake",
  POSTGRES_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/postgresql",
  REDSHIFT_AI_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/agentic-gateway/mcp-server/redshift",

  // Notifiers
  SLACK_INSTALL: "https://docs.p0.dev/integrations/notifier-integrations/slack",
  TEAMS_INSTALL:
    "https://docs.p0.dev/integrations/notifier-integrations/microsoft-teams",
  AWS_LAMBDA_NOTIFIER_INSTALL:
    "https://docs.p0.dev/integrations/notifier-integrations/custom-notifiers/aws-lambda-notifier",
  EMAIL_INSTALL: "https://docs.p0.dev/integrations/notifier-integrations/email",

  // Directories
  GOOGLE_WORKSPACE_INSTALL:
    "https://docs.p0.dev/integrations/directory-integrations/google-workspace",
  ENTRA_ID_LEGACY_INSTALL:
    "https://docs.p0.dev/integrations/directory-integrations/microsoft-entra-id-legacy",
  ENTRA_ID_INSTALL:
    "https://docs.p0.dev/integrations/directory-integrations/microsoft-entra-id",
  OKTA_INSTALL: "https://docs.p0.dev/integrations/directory-integrations/okta",
  OKTA_GROUP_ASSIGNMENT:
    "https://docs.p0.dev/integrations/directory-integrations/okta#configure-group-management",

  // Approvers
  PAGERDUTY_INSTALL:
    "https://docs.p0.dev/integrations/approval-integrations/pagerduty",
  INCIDENTIO_INSTALL:
    "https://docs.p0.dev/integrations/approval-integrations/incidentio",
  GRAFANA_IRM_INSTALL:
    "https://docs.p0.dev/integrations/approval-integrations/grafana-irm",

  // Trackers
  JIRA_INSTALL: "https://docs.p0.dev/tracker-integrations/jira",

  // SIEM
  SPLUNK_INSTALL:
    "https://docs.p0.dev/integrations/siem-integrations/splunk-hec-setup",
  DATADOG_INSTALL:
    "https://docs.p0.dev/integrations/siem-integrations/datadog-setup",
  AWS_SQS_INSTALL:
    "https://docs.p0.dev/integrations/siem-integrations/amazon-sqs-setup",
  AWS_S3_AUDIT_INSTALL:
    "https://docs.p0.dev/integrations/siem-integrations/amazon-s3-audit-setup",

  // AI gateway
  AGENTIC_GATEWAY_EKS_AUTO_MODE_STORAGE:
    "https://docs.p0.dev/getting-started/deploying-the-p0-mcp-gateway#eks-auto-mode-storage",
} as const;

/** Component-level documentation URLs, keyed by `${integration}/${component}` */
export const COMPONENT_DOCS_URLS: Record<string, string> = {
  // AWS
  "aws/iam-write": DOCS_URLS.AWS_IAM_WRITE,
  "aws/iam-assessment": DOCS_URLS.IAM_ASSESSMENT_CREATE_ENVIRONMENT,
  "aws/inventory": DOCS_URLS.AWS_INVENTORY,
  "aws/access-logs": DOCS_URLS.AWS_ACCESS_LOGS,
  "aws/function-caller": DOCS_URLS.AWS_FUNCTION_CALLER,
  "aws/rds-security-perimeter": DOCS_URLS.AWS_RDS_SECURITY_PERIMETER,

  // Google Cloud
  "gcloud/iam-write": DOCS_URLS.GCLOUD_INSTALL,
  "gcloud/iam-assessment": DOCS_URLS.IAM_ASSESSMENT_CREATE_ENVIRONMENT,
  "gcloud/iam-write-security-perimeter": DOCS_URLS.GCLOUD_SECURITY_PERIMETER,
  "gcloud/function-caller": DOCS_URLS.GCLOUD_FUNCTION_CALLER,

  // Azure
  "azure/azure-app": DOCS_URLS.AZURE_APP,
  "azure/iam-write": DOCS_URLS.AZURE_IAM_WRITE,
  "azure/bastion-host": DOCS_URLS.AZURE_BASTION_HOST,

  // Kubernetes
  "k8s/iam-write": DOCS_URLS.K8S_INSTALL,

  // PostgreSQL
  "pg/access-management": DOCS_URLS.POSTGRES_INSTALL,

  // Snowflake
  "snowflake/iam-write": DOCS_URLS.SNOWFLAKE_INSTALL,

  // SSH
  "ssh/iam-write": DOCS_URLS.SSH_INSTALL,

  // Self-hosted
  "self-hosted/iam-write": DOCS_URLS.SELF_HOSTED_INSTALL,

  // Tailscale
  "tailscale/connector": DOCS_URLS.TAILSCALE_INSTALL,
  "tailscale/tailnet": DOCS_URLS.TAILSCALE_INSTALL,

  // Okta
  "okta/listing": DOCS_URLS.OKTA_INSTALL,
  "okta/group-assignment": DOCS_URLS.OKTA_GROUP_ASSIGNMENT,

  // Entra ID
  "entra-id/iam-write": DOCS_URLS.ENTRA_ID_INSTALL,
  "azure-ad/iam-write": DOCS_URLS.ENTRA_ID_LEGACY_INSTALL,

  // Splunk
  "splunk/audit-log": DOCS_URLS.SPLUNK_INSTALL,
  "datadog/audit-log": DOCS_URLS.DATADOG_INSTALL,
  "aws-sqs/audit-log": DOCS_URLS.AWS_SQS_INSTALL,
  "aws-s3-audit/audit-log": DOCS_URLS.AWS_S3_AUDIT_INSTALL,

  // Custom
  "custom/iam-write": DOCS_URLS.CUSTOM_INSTALL,

  // ClickHouse Cloud
  "clickhouse/connector": DOCS_URLS.CLICKHOUSE_INSTALL,
  "clickhouse/organization": DOCS_URLS.CLICKHOUSE_INSTALL,

  // GitHub
  "github/repository-access": DOCS_URLS.GITHUB_INSTALL,
  "github-repositories/repository-access":
    DOCS_URLS.GITHUB_REPOSITORIES_INSTALL,

  // Docker Hub
  "docker/connector": DOCS_URLS.DOCKER_INSTALL,
  "docker/organization": DOCS_URLS.DOCKER_INSTALL,

  // 1Password
  "1password/connector": DOCS_URLS.ONEPASSWORD_INSTALL,
  "1password/vault": DOCS_URLS.ONEPASSWORD_INSTALL,

  // Auth0
  "auth0/connector": DOCS_URLS.AUTH0_INSTALL,
  "auth0/tenant": DOCS_URLS.AUTH0_INSTALL,

  // AWS Lambda Notifier
  "aws-lambda-notifier/notify": DOCS_URLS.AWS_LAMBDA_NOTIFIER_INSTALL,
};
